"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartThemeOptions = void 0;
// Highcharts ignores the MUI theme and paints a white chart with dark text,
// so dark mode needs explicit colors. Light returns {} to keep Highcharts'
// defaults untouched. Merge it under the chart's own options
// (`Highcharts.merge(chartThemeOptions(theme), options)`) and remount the
// chart when the mode changes (e.g. `key={theme.palette.mode}`), since a
// chart.update() back to light can't restore the defaults.
var chartThemeOptions = function (theme) {
    if (theme.palette.mode !== "dark")
        return {};
    var _a = theme.palette, text = _a.text, grey = _a.grey, background = _a.background, divider = _a.divider, action = _a.action;
    var axis = {
        labels: { style: { color: text.secondary } },
        title: { style: { color: text.secondary } },
        gridLineColor: grey[300],
        minorGridLineColor: grey[200],
        lineColor: grey[400],
        tickColor: grey[400],
    };
    return {
        // Highcharts default series colors, with the near-black #434348 swapped
        // for a grey that reads on a dark surface.
        colors: [
            "#7cb5ec",
            grey[600],
            "#90ed7d",
            "#f7a35c",
            "#8085e9",
            "#f15c80",
            "#e4d354",
            "#2b908f",
            "#f45b5b",
            "#91e8e1",
        ],
        chart: { backgroundColor: "transparent" },
        title: { style: { color: text.primary } },
        subtitle: { style: { color: text.secondary } },
        xAxis: axis,
        yAxis: axis,
        colorAxis: { labels: { style: { color: text.secondary } } },
        legend: {
            itemStyle: { color: text.primary },
            itemHoverStyle: { color: theme.palette.common.white },
            itemHiddenStyle: { color: text.disabled },
            title: { style: { color: text.primary } },
        },
        tooltip: {
            backgroundColor: grey[100],
            style: { color: text.primary },
        },
        plotOptions: {
            series: {
                dataLabels: { color: text.primary, style: { textOutline: "none" } },
            },
            pie: { borderColor: background.paper },
        },
        drilldown: {
            activeAxisLabelStyle: { color: text.primary },
            activeDataLabelStyle: { color: text.primary },
            drillUpButton: {
                theme: {
                    fill: grey[200],
                    stroke: grey[400],
                    style: { color: text.primary },
                    states: { hover: { fill: grey[300] } },
                },
            },
        },
        loading: {
            style: { backgroundColor: background.paper },
            labelStyle: { color: text.primary },
        },
        navigation: {
            buttonOptions: {
                symbolStroke: text.secondary,
                theme: {
                    fill: background.paper,
                    states: { hover: { fill: grey[200] }, select: { fill: grey[300] } },
                },
            },
            menuStyle: {
                background: background.paper,
                border: "1px solid ".concat(divider),
            },
            menuItemStyle: { color: text.primary },
            menuItemHoverStyle: { background: action.hover, color: text.primary },
        },
    };
};
exports.chartThemeOptions = chartThemeOptions;
//# sourceMappingURL=chartStyles.js.map